var exports = {
  "jM": "mcpDialog__8NivcE",
  "MY": "page__e2Wlb6",
  "wx": "header__U_RHiF",
  "DD": "title__JAsSKT",
  "nd": "panel__xsipfv",
  "vR": "tabs__4GBdvW",
  "Lq": "loading__7ucjqu",
};

module.exports = exports;
